var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg5Star = function Svg5Star(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959,
    y: -107,
    display: "inline",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    width: 1428,
    height: 1012
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.842,56.158c-1.308,0-2.368,1.06-2.368,2.368c0,7.574-8.288,13.737-18.474,13.737s-18.474-6.163-18.474-13.737   c0-1.308-1.06-2.368-2.368-2.368c-1.308,0-2.368,1.06-2.368,2.368C26.789,68.713,37.201,77,50,77s23.211-8.287,23.211-18.474   C73.211,57.218,72.15,56.158,70.842,56.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.955,47.944c1.987,0,3.974-0.756,5.486-2.269c3.025-3.025,3.025-7.946,0-10.971c-0.925-0.925-2.424-0.925-3.349,0   c-0.925,0.925-0.925,2.424,0,3.349c0,0,0,0,0,0c1.178,1.178,1.178,3.095,0,4.273c-1.142,1.14-3.132,1.142-4.273,0l0,0   c-0.925-0.925-2.424-0.925-3.349,0c-0.925,0.925-0.925,2.424,0,3.349C28.982,47.188,30.968,47.944,32.955,47.944z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.045,47.944c1.986,0,3.973-0.756,5.485-2.269c0.925-0.925,0.925-2.424,0-3.349c-0.925-0.925-2.424-0.925-3.349,0l0,0   c-1.143,1.142-3.132,1.14-4.273,0c-1.178-1.178-1.178-3.095,0-4.273c0,0,0,0,0,0c0.925-0.925,0.925-2.424,0-3.349   c-0.925-0.925-2.424-0.925-3.349,0c-3.025,3.025-3.025,7.946,0,10.971C63.072,47.188,65.058,47.944,67.045,47.944z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,95c24.813,0,45-20.187,45-45S74.813,5,50,5S5,25.187,5,50S25.187,95,50,95z M50,9.737   c22.201,0,40.263,18.062,40.263,40.263S72.201,90.263,50,90.263S9.737,72.201,9.737,50S27.799,9.737,50,9.737z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg5Star, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5star.2bc20bcb.svg";
export { ForwardRef as ReactComponent };